import React from "react";
import { Box, Typography } from "@mui/material";
import { CalendarMonth } from "@mui/icons-material";
import moment from "moment";

// SectionWrapper
export const SectionWrapper = ({ children }) => (
  <Box
    sx={{
      p: 3,
      borderRadius: 2,
      boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
      border: "1px solid #e2e8f0",
    }}
  >
    {children}
  </Box>
);

// Icon wrapper for displaying icon + text row
export const IconWrapper = ({ children }) => (
  <Box sx={{ display: "flex", alignItems: "center", gap: 1, color: "gray" }}>{children}</Box>
);

// Section header with icon and title
export const SectionHeader = ({ icon, title }) => (
  <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
    {icon}
    <Typography variant="h6" fontWeight="600">
      {title}
    </Typography>
  </Box>
);

// Date range component for showing start and end dates
export const DateRange = ({ startDate, endDate }) => (
  <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, fontSize: 14, color: "gray" }}>
    <CalendarMonth fontSize="small" color="info" />
    <span>
      {startDate ? moment(startDate).format("MMM YYYY") : ""}
      {startDate ? " - " : ""}
      {endDate ? moment(endDate).format("MMM YYYY") : "Present"}
    </span>
  </Box>
);

// Format URL to ensure it has http/https prefix
export const formatUrl = (url) => {
  if (!url) return "";
  return url.startsWith("http://") || url.startsWith("https://") ? url : `https://${url}`;
};
